var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparatorElipse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5854 8C20.5854 9.8271 19.6079 11.5548 17.8821 12.8591C16.1557 14.1638 13.7259 15 11 15C8.27421 15 5.84436 14.1638 4.11799 12.8591C2.39219 11.5548 1.41467 9.8271 1.41467 8C1.41467 6.1729 2.39219 4.44522 4.11799 3.14093C5.84436 1.83622 8.27421 1 11 1C13.7259 1 16.1557 1.83622 17.8821 3.14093C19.6079 4.44522 20.5854 6.1729 20.5854 8Z",
    stroke: "#D8E7E0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorElipse);
export default __webpack_public_path__ + "static/media/separator-elipse.d7300e64bf60da9b570756e561793433.svg";
export { ForwardRef as ReactComponent };